import { render, staticRenderFns } from "./Useradmin.vue?vue&type=template&id=f1408732&scoped=true"
import script from "./Useradmin.vue?vue&type=script&lang=js"
export * from "./Useradmin.vue?vue&type=script&lang=js"
import style0 from "./Useradmin.vue?vue&type=style&index=0&id=f1408732&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1408732",
  null
  
)

export default component.exports